<template>
    <div class="container">
        <div class="row"><h4>Canvas</h4></row>

        <div id="can"></div>

        </div>
    </div>
</template>

<script>
// https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Drawing_shapes

// import main from './../../../js/canvas/basic-modules/main';
// import canv from './../../../js/canvas/basic-modules/modules/canvas';
import { create, createReportList } from  './../../../js/canvas/basic-modules/modules/canvas';
import { name, draw, reportArea, reportPerimeter } from './../../../js/canvas/basic-modules/modules/square';
import randomSquare from './../../../js/canvas/basic-modules/modules/square.js';

export default {
    name:'CanvasTest',
    props:{
        // images: {
        //     type:String,
        //     default:[]
        // },
        // downloadables: {
        //     type:String,
        //     default:[]
        // }
    },
    data(){
        return {
            // selasset:'',

        }
    },
    mounted() {
        console.log('Component mounted.');
        // this.imgList;
        // this.dwnList;
        this.fire();
    },
    methods: {
        fire() {
            let canv = document.getElementById('can');
            let myCanvas = create('myCanvas', canv, 480, 320);
            let reportList = createReportList(myCanvas.id);

            let square1 = draw(myCanvas.ctx, 50, 50, 100, 'blue');
            // reportArea(square1.length, reportList);
            // reportPerimeter(square1.length, reportList);

//             // Use the default
let square2 = randomSquare(myCanvas.ctx);

 myCanvas.ctx.fillStyle = "rgb(200,0,0)";
    myCanvas.ctx.fillRect(10, 10, 55, 50);

// let circleBtn = document.querySelector('.circle');
// let squareBtn = document.querySelector('.square');
// let triangleBtn = document.querySelector('.triangle');
// myCanvas.create();
// myCanvas.createReportList();
// // draw a square
// squareBtn.addEventListener('click', () => {
//   import('./../../../js/canvas/square.js').then((Module) => {
//     let square1 = new Module.Square(myCanvas.ctx, myCanvas.listId, 50, 50, 100, 'blue');
//     square1.draw();
//     square1.reportArea();
//     square1.reportPerimeter();
//   })
// });

// // draw a circle
// circleBtn.addEventListener('click', () => {
//   import('./../../../js/canvas/circle.js').then((Module) => {
//     let circle1 = new Module.Circle(myCanvas.ctx, myCanvas.listId, 75, 200, 100, 'green');
//     circle1.draw();
//     circle1.reportArea();
//     circle1.reportPerimeter();
//   })
// });

// // draw a triangle
// triangleBtn.addEventListener('click', () => {
//   import('./../../../js/canvas/triangle.js').then((Module) => {
//     let triangle1 = new Module.Triangle(myCanvas.ctx, myCanvas.listId, 100, 75, 190, 'yellow');
//     triangle1.draw();
//     triangle1.reportArea();
//     triangle1.reportPerimeter();
//   })
// });



        }


    },
    computed:{
        // imgList(){
        //     if(this.images) this.imageList = JSON.parse(this.images);
        //     return this.imageList;
        // },
        // dwnList(){
        //     if(this.downloadables) this.downloadList = JSON.parse(this.downloadables);
        //     return this.downloadList;
        // }
    }
}

</script>
<style scoped>

</style>
